/* =========================================================================
   Upgreens: Kaufabteil — Auswahl, laufende Summe, Warenkorb

   ZWEI AUFGABEN:

   1. LAUFENDE SUMME
      Grundpreis der gewaehlten Variante plus alles Angekreuzte. Die Preise
      kommen als JSON aus dem Liquid — der Text im Preisfeld wird bewusst
      NICHT geparst, das waere waehrungs- und formatabhaengig.
      Die aktuelle Variante steht im Formularfeld `id`, das Motto beim
      Variantenwechsel selbst aktualisiert.

   2. ZUSATZARTIKEL IN DEN WARENKORB
      Mottos Formular (assets/product-form.js) baut FormData und postet an
      /cart/add.js — dort passt genau EIN Artikel hinein.

      Statt Mottos Logik zu ersetzen, klinken wir uns davor:
        a) Klick auf den Kaufen-Knopf abfangen (capture-Phase)
        b) Gewaehltes per /cart/add.js zulegen
        c) Knopf erneut ausloesen — jetzt laeuft Mottos Ablauf normal durch

      So bleibt Mottos Code unangetastet und wir erben Fehlerbehandlung,
      Ladezustand und das Oeffnen der Warenkorb-Schublade.
   ========================================================================= */
(function () {
  'use strict';

  /* „inkl. 1 Zusatz" kommt aus snippets/ug-texte.liquid, damit es in
     Translate & Adapt steht. Fehlt das Snippet, gilt der deutsche Notnagel. */
  function ugZusatz(anzahl) {
    var schluessel = anzahl === 1 ? "zusatz_eins" : "zusatz_mehr";
    var notnagel = anzahl === 1 ? "inkl. {anzahl} Zusatz" : "inkl. {anzahl} Zusätzen";
    if (window.ugText) return window.ugText(schluessel, notnagel, { anzahl: anzahl });
    return notnagel.split("{anzahl}").join(String(anzahl));
  }

  var MARKE = 'ugAddonsErledigt';

  /* ---- Hilfen ----------------------------------------------------------- */

  function preistabelle(bereich) {
    var el = bereich.querySelector('[data-ug-preise]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[ug-addons] Preistabelle unlesbar:', e);
      return {};
    }
  }

  function gewaehlte(bereich) {
    var artikel = [];
    Array.prototype.forEach.call(bereich.querySelectorAll('[data-ug-wahl]'), function (feld) {
      if (feld.checked && feld.value && !feld.disabled) {
        artikel.push({
          id: Number(feld.value),
          preis: Number(feld.dataset.ugPreis || 0),
        });
      }
    });
    return artikel;
  }

  function formatiere(cent, waehrung) {
    var wert = cent / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: waehrung || 'EUR',
      }).format(wert);
    } catch (e) {
      return wert.toFixed(2) + ' ' + (waehrung || '');
    }
  }

  /* ---- Summe ------------------------------------------------------------ */

  function summeAktualisieren(bereich, formular) {
    var anzeige = bereich.querySelector('[data-ug-summe]');
    var wertEl = bereich.querySelector('[data-ug-summe-wert]');
    if (!anzeige || !wertEl) return;

    var artikel = gewaehlte(bereich);
    var preise = bereich.__ugPreise || (bereich.__ugPreise = preistabelle(bereich));
    var idFeld = formular && formular.querySelector('[name="id"]');
    var basis = idFeld ? Number(preise[idFeld.value] || 0) : 0;

    var summe = artikel.reduce(function (s, a) {
      return s + a.preis;
    }, basis);

    wertEl.textContent = formatiere(summe, bereich.dataset.ugWaehrung);

    // Zusatzhinweis nur, wenn wirklich etwas gewaehlt wurde
    var zusatz = bereich.querySelector("[data-ug-summe-zusatz]");
    if (zusatz) {
      zusatz.textContent = artikel.length
        ? ugZusatz(artikel.length)
        : "";
    }

    anzeige.hidden = false;
  }

  /* ---- Warenkorb -------------------------------------------------------- */

  function zulegen(artikel) {
    var ziel =
      window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

    return fetch(ziel, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: artikel.map(function (a) {
          return { id: a.id, quantity: 1 };
        }),
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function knopfVerdrahten(knopf, formular, bereich) {
    if (knopf.dataset.ugAddonsBereit) return;
    knopf.dataset.ugAddonsBereit = '1';

    knopf.addEventListener(
      'click',
      function (ereignis) {
        // Zweiter Durchlauf: durchlassen, Motto uebernimmt
        if (knopf.dataset[MARKE]) {
          delete knopf.dataset[MARKE];
          return;
        }

        var artikel = gewaehlte(bereich);
        if (!artikel.length) return; // nichts gewaehlt, normaler Ablauf

        ereignis.preventDefault();
        ereignis.stopPropagation();
        knopf.setAttribute('aria-busy', 'true');

        zulegen(artikel)
          .catch(function (fehler) {
            // Schlaegt das Zulegen fehl, soll wenigstens das Hauptprodukt
            // im Warenkorb landen — deshalb nur melden, nicht abbrechen.
            console.error('[ug-addons] Zusatzartikel konnten nicht gelegt werden:', fehler);
          })
          .then(function () {
            knopf.removeAttribute('aria-busy');
            knopf.dataset[MARKE] = '1';
            knopf.click();
          });
      },
      true
    );
  }

  /* ---- Fenster ---------------------------------------------------------- */

  function fensterVerdrahten(bereich) {
    bereich.querySelectorAll('[data-ug-addon-oeffnen]').forEach(function (ausloeser) {
      ausloeser.addEventListener('click', function () {
        var f = document.getElementById(ausloeser.dataset.ugAddonOeffnen);
        if (f && typeof f.showModal === 'function') f.showModal();
      });
    });

    document.querySelectorAll('[data-ug-addon-schliessen]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var f = knopf.closest('dialog');
        if (f) f.close();
      });
    });

    document.querySelectorAll('.ug-fenster').forEach(function (f) {
      f.addEventListener('click', function (e) {
        if (e.target === f) f.close();
      });
    });
  }

  /* ---- Start ------------------------------------------------------------ */

  function start() {
    document.querySelectorAll('[data-ug-addons]').forEach(function (bereich) {
      var formular =
        bereich.closest('.product__info-container')?.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');

      fensterVerdrahten(bereich);

      // Auswahl wirkt sofort auf die Summe
      bereich.addEventListener('change', function () {
        summeAktualisieren(bereich, formular);
      });

      // Variantenwechsel aendert den Grundpreis
      if (formular) {
        formular.addEventListener('change', function () {
          summeAktualisieren(bereich, formular);
        });
      }

      summeAktualisieren(bereich, formular);

      document.querySelectorAll('.product-form__submit').forEach(function (knopf) {
        var f = knopf.closest('form');
        if (f) knopfVerdrahten(knopf, f, bereich);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
